import React from "react";
import styles from "./FooterFeedback.module.scss";

import correctFeedbackImage from "./images/CorrectFeedback.svg";
import incorrectFeedbackImage from "./images/IncorrectFeedback.svg";

interface FooterFeedbackProps {
  feedback: string;
  correct: boolean;
  display: boolean;
}

export function FooterFeedback(props: FooterFeedbackProps) {
  const feedbackImage = props.correct
    ? correctFeedbackImage
    : incorrectFeedbackImage;

  return (
    <>
      {props.display && (
        <div
          className={`${props.correct ? styles.correctContainer : styles.incorrectContainer}`}
        >
          <img src={feedbackImage} alt="Feedback" />
          <div
            className={`${props.correct ? styles.cellCorrect : styles.cellIncorrect}`}
          >
            {props.feedback}
          </div>
        </div>
      )}
    </>
  );
}
